import { Injectable, inject } from "@angular/core";
import type { BaseFilterDefinition, FilterOption, FilterValue } from "../filter.types";
import type { IBaseCard, JobsBillingCard, IBaseT1Card, TranslateObject } from "@app/views-interfaces";
import { StepsService } from "@shared/steps-service";
import { SimpleFilterMulti } from "./types/simple-filter-multi";

abstract class StepsFilterService<TItem extends IBaseCard> extends SimpleFilterMulti<TItem> {
    private readonly stepsService = inject(StepsService);
    protected noneOption: FilterOption | null = { value: "", label: "General.None" };

    protected abstract getStatusId(item: TItem): string | undefined;

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "Step",
            label: "AllView.Step",
        };
    }

    protected getValue(item: TItem): FilterValue | undefined {
        const statusId = this.getStatusId(item);
        if (!statusId) return;

        return this.stepsService.currentStepByTaxReturnStatusId().get(statusId)?.Id;
    }

    protected getLabel(stepId: string): string | undefined | null | TranslateObject {
        return this.stepsService.currentSteps()?.find((step) => step.Id === stepId)?.Name;
    }

    protected getAllValues(): readonly string[] {
        return this.stepsService.currentSteps()?.flatMap((step) => (step.Id ? [step.Id] : [])) ?? [];
    }
}

@Injectable()
export class JobStepFilterService extends StepsFilterService<JobsBillingCard> {
    protected getStatusId(item: JobsBillingCard): string | undefined {
        return item.job?.statusId;
    }
}

@Injectable()
export class IFirmStepFilterService extends StepsFilterService<IBaseT1Card> {
    protected getStatusId(item: IBaseT1Card): string | undefined {
        return item.return?.statusId;
    }
}
